import { render, staticRenderFns } from "./EventDetailsTicketsStep.vue?vue&type=template&id=639f98d8"
import script from "./EventDetailsTicketsStep.vue?vue&type=script&lang=js"
export * from "./EventDetailsTicketsStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports